export const formatCurrency = (cents, format) => {
    const money_format = '${{amount}}';
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || money_format;
    const defaultOption = (opt, def) => {
        return typeof opt == 'undefined' ? def : opt;
    };
    const formatWithDelimiters = (number, precision, thousands, decimal) => {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
    };
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};
export const getMoneyFormat = (selectedCountry) => {
    switch (selectedCountry.currency.isoCode) {
        case 'IDR':
            return `${selectedCountry.currency.symbol} {{amount_with_comma_separator}}`;
        case 'JPY':
            return `${selectedCountry.currency.symbol}{{amount_no_decimals_with_comma_separator}}`;
        case 'MYR':
            return `${selectedCountry.currency.symbol}{{amount_no_decimals_with_comma_separator}} ${selectedCountry.currency.isoCode}`;
        case 'KRW':
            return `${selectedCountry.currency.symbol}{{amount_no_decimals}}`;
        case 'THB':
            return `{{amount}} ${selectedCountry.currency.symbol}`;
        default:
            return `${selectedCountry.currency.symbol}{{amount}}`;
    }
};
